import classNames from 'classnames';
import React, { useState } from 'react';
import { Icons, PrimaryButton } from '../../../../components';
import Slider from 'react-slick';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';
import css from './SectionTalentHero.module.css';
import brandImg1 from '../../../../assets/EnhancedServices/MentorshipIcon.png';
import campaignImg1 from '../../../../assets/sport-img1.png';
import campaignImg2 from '../../../../assets/sport-img2.png';
import campaignImg3 from '../../../../assets/sport-img3.png';
import { useIntl } from 'react-intl';

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const brandSliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

function RenderTalentPlusTabs({ isMobileLayout }) {
  const [activeTab, setActiveTab] = useState('Talent Videos');

  const renderContent = () => {
    switch (activeTab) {
      case 'Talent Videos':
        return (
          <div
            className={classNames(
              css.postedContentSection,
              css.talentVideosSection,
              css.howItWorks
            )}
          >
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Talent Videos</h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.featuredListingsContent}>
                <div className={css.templatesSlider}>
                  <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <video controls width="100%">
                          <source
                            src="https://www.w3schools.com/html/mov_bbb.mp4"
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="Bill Catch" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Highlight Reel 2024</p>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="eye" /> 120
                              </span>
                              <span>
                                <Icons name="messageBox" /> 15
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <video controls width="100%">
                          <source
                            src="https://www.w3schools.com/html/mov_bbb.mp4"
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg2} alt="Bill Catch" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Training Session</p>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="eye" /> 95
                              </span>
                              <span>
                                <Icons name="messageBox" /> 8
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <video controls width="100%">
                          <source
                            src="https://www.w3schools.com/html/mov_bbb.mp4"
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg3} alt="Bill Catch" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Game Highlights</p>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="eye" /> 200
                              </span>
                              <span>
                                <Icons name="messageBox" /> 25
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        );
      case 'Join A Fan Chat':
        return (
          <div className={classNames(css.postedContentSection, css.howItWorks)}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Fan Chat</h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.featuredListingsContent}>
                <div className={css.templatesSlider}>
                  <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                          </div>
                        </div>
                      </div>
                      <div className={css.memberSec}>
                        <span>
                          <Icons name="users" /> 6 members
                        </span>
                        <span>
                          <Icons name="dateOfBirth" /> May 20, 2024
                        </span>
                      </div>
                      <div className={css.channelSec}>
                        <h3>Channels</h3>
                        <p>
                          All
                          <span>
                            202 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Steve 101
                          <span>
                            0 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Gameplay tips
                          <span>
                            32 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Chips
                          <span>
                            572 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Match up
                          <span>
                            192 <Icons name="message" />
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                          </div>
                        </div>
                      </div>
                      <div className={css.memberSec}>
                        <span>
                          <Icons name="users" /> 6 members
                        </span>
                        <span>
                          <Icons name="dateOfBirth" /> May 20, 2024
                        </span>
                      </div>
                      <div className={css.channelSec}>
                        <h3>Channels</h3>
                        <p>
                          All
                          <span>
                            202 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Steve 101
                          <span>
                            0 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Gameplay tips
                          <span>
                            32 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Chips
                          <span>
                            572 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Match up
                          <span>
                            192 <Icons name="message" />
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                          </div>
                        </div>
                      </div>
                      <div className={css.memberSec}>
                        <span>
                          <Icons name="users" /> 6 members
                        </span>
                        <span>
                          <Icons name="dateOfBirth" /> May 20, 2024
                        </span>
                      </div>
                      <div className={css.channelSec}>
                        <h3>Channels</h3>
                        <p>
                          All
                          <span>
                            202 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Steve 101
                          <span>
                            0 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Gameplay tips
                          <span>
                            32 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Chips
                          <span>
                            572 <Icons name="message" />
                          </span>
                        </p>
                        <p>
                          Match up
                          <span>
                            192 <Icons name="message" />
                          </span>
                        </p>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        );
      case 'Join a 1-on-1 Video Call':
        return (
          <div className={classNames(css.postedContentSection, css.howItWorks)}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Join a 1-on-1 Video Call</h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.featuredListingsContent}>
                <div className={css.templatesSlider}>
                  <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>University</p>
                            <span className={css.rating}>
                              <Icons name="star" /> 4.8
                            </span>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.otherInfo}>
                        <Icons name="thunder" /> It's began! The doctor is waiting for you.
                      </div>
                      <PrimaryButton>Go to appointment</PrimaryButton>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>University</p>
                            <span className={css.rating}>
                              <Icons name="star" /> 4.8
                            </span>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.otherInfo}>
                        <Icons name="thunder" /> It's began! The doctor is waiting for you.
                      </div>
                      <PrimaryButton>Go to appointment</PrimaryButton>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>University</p>
                            <span className={css.rating}>
                              <Icons name="star" /> 4.8
                            </span>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.otherInfo}>
                        <Icons name="thunder" /> It's began! The doctor is waiting for you.
                      </div>
                      <PrimaryButton>Go to appointment</PrimaryButton>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        );
      case 'Join Live Streaming':
        return (
          <div className={classNames(css.liveStreamingSection, css.howItWorks)}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Live Streaming</h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.featuredListingsContent}>
                <div className={css.templatesSlider}>
                  <Slider {...{ ...brandSliderSettings, arrows: !isMobileLayout }}>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <img src={campaignImg1} alt="name" />
                      </div>
                      <span className={css.totalView}>
                        <Icons name="eye" /> 35
                      </span>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="messageBox" /> 5
                              </span>
                              <span>
                                <Icons name="tag" /> 30
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <img src={campaignImg1} alt="name" />
                      </div>
                      <span className={css.totalView}>
                        <Icons name="eye" /> 35
                      </span>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="messageBox" /> ером5
                              </span>
                              <span>
                                <Icons name="tag" /> 30
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockImg} role="button">
                        <img src={campaignImg1} alt="name" />
                      </div>
                      <span className={css.totalView}>
                        <Icons name="eye" /> 35
                      </span>
                      <div className={css.blockUserInfoWrapper}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <div className={css.timeSec}>
                              <span>
                                <Icons name="messageBox" /> 5
                              </span>
                              <span>
                                <Icons name="tag" /> 30
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        );
      case 'Social Media Feeds':
        return (
          <div className={classNames(css.postedContentSection, css.howItWorks)}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Social Media Feeds</h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.featuredListingsContent}>
                <div className={css.templatesSlider}>
                  <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>12 April at 09:28 PM</p>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.description}>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore
                        fugiat doloremque doloribus quibusdam nihil ea temporibus eos architecto,
                        nulla, sunt commodi laboriosam aperiam eaque maiores libero voluptates fuga
                        consequuntur!
                      </div>
                      <div className={css.imagesGridSec}>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>12 April at 09:28 PM</p>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.description}>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore
                        fugiat doloremque doloribus quibusdam nihil ea temporibus eos architecto,
                        nulla, sunt commodi laboriosam aperiam eaque maiores libero voluptates fuga
                        consequuntur!
                      </div>
                      <div className={css.imagesGridSec}>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                      </div>
                    </div>
                    <div className={css.block}>
                      <div className={css.blockUserInfo}>
                        <div className={css.blockUserImg}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.blockUserInfo}>
                          <div className={css.blockInfoLeft}>
                            <h3>Bill Catch</h3>
                            <p>12 April at 09:28 PM</p>
                          </div>
                          <div className={css.blockInfoRight}>
                            <span className={css.menuIcon}>
                              <Icons name="menuVertical" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.description}>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore
                        fugiat doloremque doloribus quibusdam nihil ea temporibus eos architecto,
                        nulla, sunt commodi laboriosam aperiam eaque maiores libero voluptates fuga
                        consequuntur!
                      </div>
                      <div className={css.imagesGridSec}>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                        <div className={css.itemWrapper}>
                          <img src={campaignImg1} alt="name" />
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className={css.contentHeroTabs}>
        <div className={css.tabs}>
          {[
            'Talent Videos',
            'Join A Fan Chat',
            'Join a 1-on-1 Video Call',
            'Join Live Streaming',
            'Social Media Feeds',
          ].map(tab => (
            <span
              key={tab}
              className={classNames({ [css.active]: activeTab === tab })}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </span>
          ))}
        </div>
      </div>
      {renderContent()}
    </>
  );
}

export default RenderTalentPlusTabs;
